import NoInformation from "./NoInformation";

export default NoInformation;
